@defer (when dataTable) {
  <app-data-table [dataTable]="dataTable" [canSelect]="true" (onSelectChange)="postToggle()" dataTableKey="reports:collections" />
}
